<!-- SEARCH BAR -->
@if (visualizza === 'SEARCHBAR') {
  <div class="search-container" [class.open]="isSearchOpen" (click)="onFocusInput()">
    <mat-form-field class="ricerca-input-documenti">
      <input
        #searchInput
        class="input-search"
        type="text"
        matInput
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        [placeholder]="'Cerca in documenti'"
        (blur)="onBlurInput()"
        [class.ellipsis]="!isSearchOpen"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
        @if (isSearchOpen) {
          <!-- MOSTRO GLI ELEMENTI FILTRATI -->
          @for (node of filteredNodes$ | async; track node.id) {
            <!-- USO (mousedown) per prevenire il blur e quindi rendere l'opzione clicacbile -->
            <mat-option
              [value]="node"
              class="custom-option"
              (mousedown)="$event.preventDefault()"
              (onSelectionChange)="optionClicked(node, $event)"
            >
              @if (isFolder(node)) {
                <!-- SE FOLDER  -->
                <div class="option-content">
                  <!-- ICONA FOLDER -->
                  <mat-icon color="accent">
                    {{
                      hasSottoCartelle($any(node)) || hasFile($any(node)) ? 'folder' : 'folder_open'
                    }}
                  </mat-icon>
                  <ng-container
                    [ngTemplateOutlet]="infoOption"
                    [ngTemplateOutletContext]="{ node: node }"
                  ></ng-container>
                </div>
              } @else {
                <!-- SE FILE  -->
                <div class="option-content" style="align-items: center">
                  <!-- LOGO IMMAGINE -->
                  <img alt="" class="option-img" [src]="getLogoFile($any(node))" height="25" />
                  <ng-container
                    [ngTemplateOutlet]="infoOption"
                    [ngTemplateOutletContext]="{ node: node }"
                  ></ng-container>
                </div>
              }
            </mat-option>
          }
        }
      </mat-autocomplete>
      <!-- Bottone search all'interno -->
      <button
        mat-icon-button
        matSuffix
        class="search-btn"
        (click)="toggleSearch(); $event.stopPropagation(); $event.preventDefault()"
      >
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>
}

@if (visualizza === 'FILTRI') {
  <div class="cnt-filtri">
    <!-- FILTRO TIPO FILE -->
    <!--     <mat-form-field 
      color="accent"
      appearance="outline"
      class="documenti-selection-filter tipo-file-filter"
    >
      <mat-label>Tipo</mat-label>
      <mat-select [formControl]="tipoFilterControl" multiple (selectionChange)="onTipoChange()">
        @for (tipoFile of tipoFileFilter; track tipoFile) {
          <mat-option class="tipo-selection-option" [value]="tipoFile">{{ tipoFile }}</mat-option>
        }
      </mat-select>
    </mat-form-field> -->

    <!-- SORT STYLE -->
    <div class="sort-container">
      <!-- PILL MOSTRATA SE C'È UNA SCELTA -->
      <div class="sort-pill" *ngIf="sortSelected" [matMenuTriggerFor]="menu">
        <span class="pill-text">
          {{ sortSelected === 'data' ? 'Data caricamento' : 'Dimensione' }}
        </span>

        <!-- Freccia ↓ per aprire il menu -->
        <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
      </div>

      <!-- ICONA PRIMARIA QUANDO NON È SELEZIONATO NULLA -->
      <button *ngIf="!sortSelected" class="icone-button" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>filter_list</mat-icon>
      </button>

      <!-- MENU -->
      <mat-menu #menu="matMenu">
        <button mat-menu-item class="btn-lista-menu" (click)="onSelectSort('data')">
          <span>Data caricamento</span>
        </button>

        <button mat-menu-item class="btn-lista-menu" (click)="onSelectSort('size')">
          <span>Dimensione</span>
        </button>
      </mat-menu>
      @if (sortSelected) {
        <div class="cnt-btn-close">
          <button
            mat-icon-button
            class="sort-action-btn"
            (click)="sortFileBy()"
            [matTooltip]="sortOrder"
          >
            <mat-icon>{{ sortOrder === 'crescente' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          </button>
        </div>
        <div class="cnt-btn-close">
          <button
            mat-icon-button
            class="sort-action-btn"
            (click)="clearSort(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
    <!-- FILTRO UTENTI -->
    <mat-form-field
      color="accent"
      appearance="outline"
      class="documenti-selection-filter utente-filter"
    >
      <mat-label>Utenti</mat-label>
      <mat-select [formControl]="utenteFilterControl" multiple (selectionChange)="onUtenteChange()">
        @for (utente of utenteFilter; track utente.id) {
          <mat-option class="tipo-selection-option" [value]="utente.id">{{
            utente.name
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}

<ng-template #infoOption let-node="node">
  <div class="name-path">
    <!-- NOME FOLDER -->
    <span class="nome-nodo">{{ node.name }}</span>
    @if (node.parentPath) {
      <!-- PATH FOLDER -->
      <span class="parent-path">{{ getVisiblePath(node.parentPath) }}</span>
    }
    <!-- <div class="utente-creazione">
      {{ nomeUtenteById(node.idUtenteCreazione) }} <span>({{ node.size | byteFormatter }})</span>
    </div> -->
  </div>
</ng-template>
